module.exports = __webpack_public_path__ + "assets/1bd9f8529af169b68d78c7ef8fe54074.mp3";